import { Grid } from "@mui/material";
import MxButtonIa from "@rf-l1/buttons/MxButtonIa";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useSeoFormActions } from "../../../../../../store/slices/SeoFormSlice";
import { useValidateSeoRequiere } from "../hooks/useValidateSeoRequiere";
import useValidateSeoFieldHasValue from "../hooks/useValidateSeoFieldHasValue";
import {
  CPropertyFormKeys,
  IPropertyForm,
  keysIndicatorsObject,
  PropertyFormSchema
} from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import useAlert from "@rf-hooks/useAlert";
import useFormStatusIndicator from "../../../../../property-header-form/hooks/useFormStatusIndicator";
import MxAlertMessage from "@rf-l1/alert/MxAlertMessage";
import MxTooltipNormal from "@rf-l1/tooltip/MxTooltipNormal";
import useSeoGenerateTitleDescription from "../hooks/useSeoGenerateTitleDescription";
import { GenerateSeoWithChatGptBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/generate-seo-with-chatgpt.values";
import useTranslateTitleDescription from "../hooks/useTranslateTitleDescription";
import useEvaluateCanTranslate from "../hooks/useEvaluateCanTranslate";
import SeoGlobalErroIndicator from "./SeoGlobalErroIndicator";
import { useErrorsFromMinimalFieldIa } from "../hooks/useErrorsFromMinimalFieldIa";

const SeoStepHeader = () => {
  const { alert } = useAlert();
  const { handleTranslateTitleDescription } = useTranslateTitleDescription();
  const { getValues, setValue } = useFormContext();
  const {
    generateSeoWithChatGpt,
    isLoadingGenerateAiDescription,
    isLoadingTranslateSection
  } = useSeoFormActions();
  const { validate } = useValidateSeoRequiere();
  const { handleOpenModalGeneratorDescriptionAndTitle } =
    useSeoGenerateTitleDescription();
  const { canEnToEs, canEsToEn, canTranslate } = useEvaluateCanTranslate();

  const { evaluateAndConfirmFieldReplacement } = useValidateSeoFieldHasValue([
    CPropertyFormKeys.seo_title_en_property,
    CPropertyFormKeys.seo_short_description_en_property,
    CPropertyFormKeys.seo_description_en_property,
    CPropertyFormKeys.seo_keywords_en_property,
    CPropertyFormKeys.seo_title_es_property,
    CPropertyFormKeys.seo_short_description_es_property,
    CPropertyFormKeys.seo_description_es_property,
    CPropertyFormKeys.seo_keywords_es_property
  ]);

  const { getErrors } = useErrorsFromMinimalFieldIa();

  const errorsList = getErrors();
  const hasErrors = errorsList.length > 0;

  const onValidate = useCallback(async () => {
    const _v = await validate();
    if (_v) {
      const _res = await evaluateAndConfirmFieldReplacement();
      if (_res) {
        handleOpenModalGeneratorDescriptionAndTitle(
          getValues().instructions_ia
        ).then(x => {
          const {
            seo_description_en_property,
            seo_description_es_property,
            seo_title_en_property,
            seo_keywords_en_property,
            seo_title_es_property,
            seo_keywords_es_property,
            seo_short_description_en_property,
            seo_short_description_es_property,
            ...rest
          } = getValues() as IPropertyForm;

          const data: GenerateSeoWithChatGptBody = {
            ...(rest as IPropertyForm),
            instructions: x.value?.description
          };

          if (x.type.confirm) {
            setValue(CPropertyFormKeys.instructions_ia, x.value?.description);
            generateSeoWithChatGpt(data);
          }
        });
        // generateAll();
      }
    } else {
      alert({
        title: "¡Atención!",
        message: (
          <>
            <MxAlertMessage>
              Asegúrese de completar todos los campos requeridos para usar la IA
              como:
              <br />
              <br />
              {errorsList.map(x => x.label).join(", ")}
            </MxAlertMessage>
          </>
        ),
        type: "warning",
        color: "warning.main",
        confirmBtnMessage: "Entendido"
      });
    }
  }, [
    validate,
    evaluateAndConfirmFieldReplacement,
    handleOpenModalGeneratorDescriptionAndTitle,
    getValues,
    setValue,
    generateSeoWithChatGpt,
    errorsList
  ]);
  return (
    <Grid container>
      <Grid item xs={12}>
        <MxTooltipNormal
          label="¡Completa los campos mínimos para que la IA entienda de que se trata tu propiedad!"
          placement="bottom"
        >
          <span>
            <MxButtonIa
              onClick={onValidate}
              loading={isLoadingGenerateAiDescription}
              disabled={hasErrors}
            >
              Título y Descripción con AI
            </MxButtonIa>
          </span>
        </MxTooltipNormal>
      </Grid>
      <Grid item xs={12}>
        <SeoGlobalErroIndicator />
      </Grid>

      <Grid item xs={12}>
        <MxButtonIa
          onClick={() => handleTranslateTitleDescription(canEsToEn, canEnToEs)}
          disabled={
            !canTranslate ||
            isLoadingTranslateSection ||
            hasErrors ||
            isLoadingGenerateAiDescription
          }
          loading={isLoadingTranslateSection}
        >
          Traducir
        </MxButtonIa>
      </Grid>
    </Grid>
  );
};

export default SeoStepHeader;
